module.exports = __webpack_public_path__ + "static/media/l-md16.8d450f87.png";